// NotificationPopup.js
import React, { useEffect, useState } from 'react';
import { X, Bell } from 'lucide-react';
import { useNotifications } from 'utils/Notifications/NotificationContext';

const NotificationPopup = () => {
  const { newNotification, dismissNewNotification } = useNotifications();
  const [isVisible, setIsVisible] = useState(false);
  const [isAnimating, setIsAnimating] = useState(false);

  useEffect(() => {
    if (newNotification) {
        // console.log("Popup triggered with:", newNotification);
      setIsVisible(true);
      setIsAnimating(true);
      
      // Auto dismiss after 5 seconds
      const timer = setTimeout(() => {
        handleDismiss();
      }, 5000);

      return () => clearTimeout(timer);
    }
  }, [newNotification]);

  const handleDismiss = () => {
    setIsAnimating(false);
    setTimeout(() => {
      setIsVisible(false);
      dismissNewNotification();
    }, 300);
  };

  const formatDate = (dateString) => {
    try {
      const date = new Date(dateString);
      const now = new Date();
      const diffInMinutes = Math.floor((now - date) / (1000 * 60));
      
      if (diffInMinutes < 1) return 'Just now';
      if (diffInMinutes < 60) return `${diffInMinutes}m ago`;
      if (diffInMinutes < 1440) return `${Math.floor(diffInMinutes / 60)}h ago`;
      return date.toLocaleDateString();
    } catch (error) {
      return dateString;
    }
  };

  if (!isVisible || !newNotification) return null;

  return (
    <div className="fixed top-4 right-4 z-[9999]">
      <div
        className={`bg-white rounded-lg shadow-2xl border border-gray-200 max-w-sm w-full transform transition-all duration-300 ${
          isAnimating 
            ? 'translate-x-0 opacity-100 scale-100' 
            : 'translate-x-full opacity-0 scale-95'
        }`}
        style={{
          boxShadow: '0 10px 25px rgba(0, 0, 0, 0.15)',
        }}
      >
        {/* Header */}
        <div className="flex items-center justify-between p-3 border-b border-gray-100">
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center">
              <Bell className="w-4 h-4 text-blue-600" />
            </div>
            <span className="font-semibold text-gray-800 text-sm">New Notification</span>
          </div>
          <button
            onClick={handleDismiss}
            className="p-1 rounded-full hover:bg-gray-100 transition-colors"
          >
            <X className="w-4 h-4 text-gray-500" />
          </button>
        </div>

        {/* Content */}
        <div className="p-3">
          <div className="flex justify-between items-start mb-2">
            <h3 className="font-medium text-[#3B0069] text-sm leading-tight">
              {newNotification.title}
            </h3>
            {/* <span className="text-xs text-gray-500 ml-2">
              {formatDate(newNotification.date)}
            </span> */}
          </div>
          <p className="text-sm text-gray-600 leading-relaxed">
            {newNotification.message}
          </p>
          
          {/* Action Button */}
          <div className="mt-3 pt-2 border-t border-gray-50">
            <button
              onClick={handleDismiss}
              className="text-xs text-[#3B0069] hover:text-[#58267F] font-medium transition-colors"
            >
              View in Notifications
            </button>
          </div>
        </div>

        {/* Progress bar for auto-dismiss */}
        <div className="h-1 bg-gray-100">
          <div 
            className="h-full bg-[#3B0069] transition-all duration-[5000ms] ease-linear"
            style={{ width: isAnimating ? '100%' : '0%' }}
          />
        </div>
      </div>
    </div>
  );
};

export default NotificationPopup;